import React from 'react'
import { view } from 'react-easy-state'
import { Result } from 'antd'

const ContentLoadingFailed = (props) => (
  <div className="content-loader">
    <Result
      status="warning"
      title="Failed to load page data"
      extra={null}
    />
  </div>
)

export default view(ContentLoadingFailed)
